import * as React from 'react';
import { Modal, UIHeading2 } from '@cian/ui-kit';

import { IBuilder, ISeller } from '../../../types/newbuildingsCompare';
import { SellersBannerContainer } from '../../../containers/NewbuildingCallToAction/SellersBanner';
import { Seller } from './Seller';
import * as style from './ShowPhonesModal.css';

export interface IShowPhonesModalProps {
  isOpen: boolean;
  newbuildingId: number;
  url: string;
  builders: IBuilder[];
  sellers: ISeller[];
  onClose(): void;
}

export const ShowPhonesModal: React.FC<IShowPhonesModalProps> = ({
  isOpen,
  newbuildingId,
  url,
  builders,
  sellers,
  onClose,
}) => {
  const title = React.useMemo(() => {
    if (builders.length === 0) {
      return 'Контакты продавцов';
    }

    if (sellers.length === 0) {
      return 'Контакты застройщиков';
    }

    return 'Контакты';
  }, [builders, sellers]);

  const isContactTypeHidden = builders.length === 0 || sellers.length === 0;

  const serviceBannerType = builders.length > 1 ? 'builder' : sellers.length > 1 ? 'seller' : null;

  return (
    <Modal header={<UIHeading2>{title}</UIHeading2>} onOpenChange={onClose} open={isOpen}>
      <div className={style['container']}>
        {builders.map(builder => (
          <Seller
            builderOrSeller={builder}
            isBuilder
            isContactTypeHidden={isContactTypeHidden}
            key={`builder-${builder.id}`}
            newbuildingId={newbuildingId}
            url={url}
          />
        ))}

        {sellers.map((seller, index) => (
          <Seller
            builderOrSeller={seller}
            isBuilder={false}
            isContactTypeHidden={isContactTypeHidden}
            key={`seller-${seller.realtyUserId ?? index}`}
            newbuildingId={newbuildingId}
            url={url}
          />
        ))}

        {serviceBannerType && (
          <SellersBannerContainer isMultipleSellers={sellers.length > 1} type={serviceBannerType} />
        )}
      </div>
    </Modal>
  );
};
